import { render, staticRenderFns } from "./AboutMyColorPc.vue?vue&type=template&id=011e3c4c&scoped=true&"
import script from "./AboutMyColorPc.vue?vue&type=script&lang=ts&"
export * from "./AboutMyColorPc.vue?vue&type=script&lang=ts&"
import style0 from "./AboutMyColorPc.vue?vue&type=style&index=0&id=011e3c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011e3c4c",
  null
  
)

export default component.exports